//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[[0,"Device",0,0],[0,"IsOpen",0,0],[0,"IsWindowOpen",0,0]],[[[],"Open",{},0,0],[[],"OpenWindow",{},0,0],[[],"Close",{},0,0],[[],"CloseWindow",{},0,0],[["msg"],"WriteLine",{},1,0],[["msg"],"WriteFullline",{},1,0],[["device_type","file_name"],"SelectDevice",{},2,0]],[]];
SPLM.ListingWindow = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.ListingWindow";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ListingWindow.DeviceType = Object.freeze({
    "Window" : "Window", "File" : "File", "FileAndWindow" : "FileAndWindow", "None" : "None"});

export default SPLM;